module.exports = __webpack_public_path__ + "static/media/speakers_logos_Annex.22cd176c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speakers_logos_Annex.jpg
// module id = 273
// module chunks = 0